import { useCallback } from 'react';

import { Filter, FilterResultStatus } from '@/components/filter';
import { Selector } from '@/components/selector';

import { CALL_MODE, CALL_STATUS } from '@/constants';

import {
  type CallModeValue,
  type CallStatusValue,
  useCallsListStore,
} from '@/store/calls-list.store';
import type { Call } from '@/types/call.type';

const CallStatusFilter = () => {
  const { filters, setFilter } = useCallsListStore();

  return (
    <Selector
      options={[{ value: 'All', label: 'All Outcome' }, ...CALL_STATUS]}
      value={filters.status}
      placeholder="All Outcome"
      onChange={value => setFilter('status', value as CallStatusValue)}
    />
  );
};

const CallModeFilter = () => {
  const { filters, setFilter } = useCallsListStore();

  return (
    <Selector
      options={[{ value: 'All', label: 'All Call Mode' }, ...CALL_MODE]}
      value={filters.mode}
      placeholder="All Call Mode"
      onChange={value => setFilter('mode', value as CallModeValue)}
    />
  );
};

export const CallsHeader = ({ calls }: { calls: Call[] }) => {
  const { setQuery, query, filters, reset } = useCallsListStore();

  const handleClearQuery = useCallback(() => setQuery(''), [setQuery]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <Filter
          placeholder="Search by phone number..."
          onFilter={setQuery}
          initialValue={query}
          onClear={handleClearQuery}
        />
        <CallStatusFilter />
        <CallModeFilter />
      </div>

      {(query || filters.status !== 'All' || filters.mode !== 'All') && (
        <FilterResultStatus
          resultsCount={calls.length}
          onReset={reset}
          message="No calls match your search"
        />
      )}
    </div>
  );
};
